var Theme = Theme || {};

Theme.MultiQuerySelectableContentList = (function ($) {

    var baseUrl;
    var query;

    return {
        init: init,
        handlePaginationClick: handlePaginationClick
    };

    function init() {
        if ($('.widget-MultiQuerySelectableContentList').length) {
            var $widgetElement = $('.js-special-collection-query');
            baseUrl = SCM.Pagination.trimEndUntilRegexMatches(document.URL.valueOf(), '[a-zA-Z]$');
            query = $widgetElement.data('query');
            SCM.Pagination.enableBrowserHistoryNavigation();
        }
    }

    function handlePaginationClick(jqElement) {
        SCM.Pagination.updateBrowseHistory(baseUrl, baseUrl);

        var ajaxSettings = {
            type: 'POST',
            url: (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') +
                '/Solr/PaginatedMultiQuerySelectableContentList/' +
                jqElement.data('parent-instance'),
            cache: false,
            data: {
                multiQuery: query,
                pageNumber: jqElement.data('clicked-page')
            }
        };

        SCM.Pagination.performAjaxPagination(ajaxSettings, jqElement);
    }


})(jQuery);
